import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { usePassThrough } from "primereact/passthrough";
import { PrimeReactProvider } from "primereact/api";
import Tailwind from "primereact/passthrough/tailwind";

import { persistor, store } from "./app/store";
import TintOverlay from "./features/accessibility/TintOverlay";
import LineReader from "./features/accessibility/LineReader";
import { ContrastObserver } from "./features/accessibility/ContrastObserver";
import App from "./App";

import "./tailwind.css";
import "./tailwind-theme-miwrite.css";
import "./tailwind-theme-utah.css";
import "./tailwind-btn.css";
import "./tailwind-tbl.css";
import "./tailwind-pre.css";
import "./tailwind-primereact-tooltip.css";

const datatableOverrides = {
	datatable: {
		root: {
			className: "relative",
		},
		loadingOverlay: {
			className:
				"!absolute inset-0 pt-8 w-full h-full min-h-[150px] bg-gray-100/40 dark:bg-gray-950/40 transition duration-200 flex items-center justify-center z-20 pointer-events-auto",
		},
	},
};

const customTailwind = usePassThrough(Tailwind, datatableOverrides, {
	mergeSections: true,
	mergeProps: false,
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
	<React.StrictMode>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<PrimeReactProvider value={{ unstyled: true, pt: customTailwind }}>
					<App />
					<TintOverlay />
					<LineReader />
					<ContrastObserver />
				</PrimeReactProvider>
			</PersistGate>
		</Provider>
	</React.StrictMode>
);
